import React, { useEffect, useState } from "react";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";

import {
  Avatar1,
  Avatar2,
  actividadIcon,
  citaIcon,
} from "../../imagepath";
import Select from "react-select";
import { Link } from "react-router-dom";
import CountUp from "react-countup";
import PatientChart from "./PaitentChart";
import { getCitasResults } from "../../../services/api";

const Admin_Dashboard = () => {
  const [actividades, setActividades] = useState([]);
  const [totalActividades, setTotalActividades] = useState(0);
  const [totalActividadesHoy, setTotalActividadesHoy] = useState(0);
  const [citas, setCitas] = useState([]);
  const [totalCitas, setTotalCitas] = useState(0);
  const [totalCitasHoy, setTotalCitasHoy] = useState(0);
  const gestor = localStorage.getItem("username");
  const [selectedActividadesOption, setSelectedActividadesOption] =
    useState(null);
  const [selectedCitasOption, setSelectedCitasOption] = useState(null);
  const [PerYear, setPerYear] = useState({});
  const filtroActividades = [
    { value: "all", label: "Todas" },
    { value: "today", label: "Hoy" },
    { value: "tomorrow", label: "Mañana" },
    { value: "next7days", label: "Próximos 7 días" },
  ];

  const filtroCitas = [
    { value: "all", label: "Todas" },
    { value: "today", label: "Hoy" },
    { value: "tomorrow", label: "Mañana" },
    { value: "next7days", label: "Próximos 7 días" },
  ];

  const [originalActividades, setOriginalActividades] = useState([]);
  const [originalCitas, setOriginalCitas] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getCitasResults(gestor, null, null, null);
        const fechaHoy = new Date().toISOString().slice(0, 10);

        //actividades
        const actividadesFiltradas = data.filter(
          (item) => item.tipo === "Actividad"
        );
        setTotalActividades(actividadesFiltradas.length);
        setActividades(actividadesFiltradas);
        setOriginalActividades(actividadesFiltradas);

        //actividades hoy
        const actividadesHoyFiltradas = actividadesFiltradas.filter(
          (item) => item.fechaAgendamiento === fechaHoy
        );
        setTotalActividadesHoy(actividadesHoyFiltradas.length);

        //citas
        const citasFiltradas = data.filter((item) => item.tipo === "Cita");
        setTotalCitas(citasFiltradas.length);
        setCitas(citasFiltradas);
        setOriginalCitas(citasFiltradas);

        //citas hoy
        const citasHoyFiltradas = citasFiltradas.filter(
          (item) => item.fechaAgendamiento === fechaHoy
        );
        setTotalCitasHoy(citasHoyFiltradas.length);

        //citas y actividades por anio
        const datosPorAnio = groupDataByYear(data);

        setPerYear(datosPorAnio);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const groupDataByYear = (data) => {
    const groupedData = {};
    data.forEach((item) => {
      const year = new Date(item.fechaAgendamiento).getFullYear();
      if (!groupedData[year]) {
        groupedData[year] = [];
      }
      groupedData[year].push(item);
    });
    return groupedData;
  };

  const handleActividadesSelectChange = (selectedActividadesOption) => {
    filterDataActividades(selectedActividadesOption.value);
  };

  const handleCitasSelectChange = (selectedCitasOption) => {
    filterDataCitas(selectedCitasOption.value);
  };

  const filterDataActividades = (option) => {
    let data;
    switch (option) {
      case "today":
        data = originalActividades.filter(
          (item) => item.fechaAgendamiento === getToday()
        );
        break;

      case "tomorrow":
        data = originalActividades.filter(
          (item) => item.fechaAgendamiento === getTomorrow()
        );
        break;

      case "next7days":
        data = originalActividades.filter(
          (item) => item.fechaAgendamiento <= getNext7Days()
        );
        break;

      case "all":
        data = originalActividades;
        break;

      default:
        break;
    }
    setActividades(data);
  };

  const filterDataCitas = (option) => {
    let data;
    switch (option) {
      case "today":
        data = originalCitas.filter(
          (item) => item.fechaAgendamiento === getToday()
        );
        break;

      case "tomorrow":
        data = originalCitas.filter(
          (item) => item.fechaAgendamiento === getTomorrow()
        );
        break;

      case "next7days":
        data = originalCitas.filter(
          (item) => item.fechaAgendamiento <= getNext7Days()
        );
        break;

      case "all":
        data = originalCitas;
        break;

      default:
        break;
    }
    setCitas(data);
  };

  const getToday = () => {
    return new Date().toISOString().slice(0, 10);
  };

  const getTomorrow = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().slice(0, 10);
  };

  const getNext7Days = () => {
    const next7days = new Date();
    next7days.setDate(next7days.getDate() + 7);
    return next7days.toISOString().slice(0, 10);
  };

  useEffect(() => {
    document.title = "Admin Dashboard";
  }, []);
  const getDashboard = () => {
    return (
      <>
        {/* Page Header */}
        <div className="page-header">
          <div className="row">
            <div className="col-sm-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="#">Acceso </Link>
                </li>
                <li className="breadcrumb-item">
                  <i className="feather-chevron-right">
                    <FeatherIcon icon="chevron-right" />
                  </i>
                </li>
                <li className="breadcrumb-item active">Admin</li>
              </ul>
            </div>
          </div>
        </div>
        {/* /Page Header */}

        <div className="row">
          <div className="col-md-6 col-sm-12 col-lg-6 col-xl-6">
            <div className="row">
              <div className="col-md-6 col-sm-6 col-lg-6 col-xl-6">
                <div className="dash-widget">
                  <div className="dash-box1 comman-flex-center">
                    <img src={actividadIcon} alt="#" />
                  </div>
                  <div className="dash-content dash-count ">
                    <h4>Intervenciones para hoy</h4>
                    <h2>
                      {" "}
                      {totalActividadesHoy ? (
                        <CountUp
                          delay={0.4}
                          end={totalActividadesHoy}
                          duration={0.6}
                        />
                      ) : (
                        0
                      )}
                    </h2>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-sm-6 col-lg-6 col-xl-6">
                <div className="dash-widget">
                  <div className="dash-box2 comman-flex-center">
                    <img src={citaIcon} alt="#" />
                  </div>
                  <div className="dash-content dash-count">
                    <h4>Consultas para hoy</h4>
                    <h2>
                      {totalCitasHoy ? (
                        <CountUp
                          delay={0.4}
                          end={totalCitasHoy}
                          duration={0.6}
                        />
                      ) : (
                        0
                      )}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 col-sm-6 col-lg-6 col-xl-6">
                <div className="dash-widget">
                  <div className="dash-box3 comman-flex-center">
                    <img src={citaIcon} alt="#" />
                  </div>
                  <div className="dash-content dash-count">
                    <h4>Consultas totales</h4>
                    <h2>
                      {totalCitas ? (
                        <CountUp delay={0.4} end={totalCitas} duration={0.6} />
                      ) : (
                        0
                      )}
                    </h2>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-sm-6 col-lg-6 col-xl-6">
                <div className="dash-widget">
                  <div className="dash-box4 comman-flex-center">
                    <img src={actividadIcon} alt="#" />
                  </div>
                  <div className="dash-content dash-count">
                    <h4>Intervenciones totales</h4>
                    <h2>
                      {totalActividades ? (
                        <CountUp
                          delay={0.4}
                          end={totalActividades}
                          duration={0.6}
                        />
                      ) : (
                        0
                      )}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-sm-12 col-lg-6 col-xl-6">
            <div className="card">
              {PerYear && <PatientChart perYear={PerYear} />}
            </div>
          </div>
        </div>
        <div className="col-12 col-md-12  col-xl-12">
          <div className="card">
            <div className="card-header">
            <h4 className="card-title d-inline-block">Intervenciones</h4>{" "}
              <Select
                className="custom-react-select"
                defaultValue={selectedActividadesOption}
                onChange={handleActividadesSelectChange}
                options={filtroActividades}
                placeholder="Seleccionar fecha"
                id="filtro-actividades"
                components={{
                  IndicatorSeparator: () => null,
                }}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderColor: state.isFocused
                      ? "none"
                      : "2px solid rgba(46, 55, 164, 0.1);",
                    boxShadow: state.isFocused ? "0 0 0 1px #2e37a4" : "none",
                    "&:hover": {
                      borderColor: state.isFocused
                        ? "none"
                        : "2px solid rgba(46, 55, 164, 0.1)",
                    },
                    borderRadius: "10px",
                    fontSize: "14px",
                    minHeight: "45px",
                  }),
                  dropdownIndicator: (base, state) => ({
                    ...base,
                    transform: state.selectProps.menuIsOpen
                      ? "rotate(-180deg)"
                      : "rotate(0)",
                    transition: "250ms",
                    width: "35px",
                    height: "35px",
                  }),
                }}
              />
            </div>
            <div className="card-body p-0 table-dash">
              <div
                className="table-responsive"
                style={{ maxHeight: "350px", overflowY: "auto" }}
              >
                {actividades.length === 0 ? (
                  <p className="text-center">No hay intervenciones para mostrar</p>
                ) : (
                  <table className="table mb-0 border-0 datatable custom-table">
                    <thead>
                      <tr>
                        <th>Intervencion</th>
                        <th>Paciente</th>
                        <th>Gestor</th>
                        <th>Fecha de vencimiento</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {actividades.map((actividad, index) => (
                        <tr key={index}>
                          <td>{actividad.actividadDe}</td>
                          <td className="table-image appoint-doctor">
                            <img
                              width={28}
                              height={28}
                              className="rounded-circle"
                              src={actividad.genero === "F" ? Avatar1 : Avatar2}
                              alt="#"
                            />
                            {actividad.nombreAfiliado}
                          </td>
                          <td>
                            <h2>{actividad.responsable}</h2>
                          </td>
                          <td className="appoint-time">
                            <span>{actividad.fechaLimite} a las </span>
                            {actividad.time}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-12  col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title d-inline-block">Consultas</h4>{" "}
              <Select
                className="custom-react-select"
                defaultValue={selectedCitasOption}
                onChange={handleCitasSelectChange}
                options={filtroCitas}
                placeholder="Seleccionar fecha"
                id="filtro-citas"
                components={{
                  IndicatorSeparator: () => null,
                }}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderColor: state.isFocused
                      ? "none"
                      : "2px solid rgba(46, 55, 164, 0.1);",
                    boxShadow: state.isFocused ? "0 0 0 1px #2e37a4" : "none",
                    "&:hover": {
                      borderColor: state.isFocused
                        ? "none"
                        : "2px solid rgba(46, 55, 164, 0.1)",
                    },
                    borderRadius: "10px",
                    fontSize: "14px",
                    minHeight: "45px",
                  }),
                  dropdownIndicator: (base, state) => ({
                    ...base,
                    transform: state.selectProps.menuIsOpen
                      ? "rotate(-180deg)"
                      : "rotate(0)",
                    transition: "250ms",
                    width: "35px",
                    height: "35px",
                  }),
                }}
              />
            </div>
            <div className="card-body p-0 table-dash">
              <div
                className="table-responsive"
                style={{ maxHeight: "350px", overflowY: "auto" }}
              >
                {citas.length === 0 ? (
                  <p className="text-center">No hay consultas para mostrar</p>
                ) : (
                  <table className="table mb-0 border-0 datatable custom-table">
                    <thead>
                      <tr>
                        <th>Consulta</th>
                        <th>Paciente</th>
                        <th>Gestor</th>
                        <th>Fecha Vencimiento</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {citas.map((cita, index) => (
                        <tr key={index}>
                          <td>{cita.actividadDe}</td>
                          <td>{cita.nombreAfiliado}</td>
                          <td className="table-image appoint-doctor">
                            <img
                              width={28}
                              height={28}
                              className="rounded-circle"
                              src={cita.genero === "F" ? Avatar1 : Avatar2}
                              alt="#"
                            />
                            <h2>{cita.nombreAfiliado}</h2>
                          </td>
                          <td>
                            <h2>{cita.responsable}</h2>
                          </td>
                          <td className="appoint-time">
                            <span>{cita.fechaLimite} a </span>
                            {cita.time}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>

          <div className="row"></div>
        </div>
      </>
    );
  };
  return <>{getDashboard()}</>;
};

export default Admin_Dashboard;
